import { render, staticRenderFns } from "./info-footer.vue?vue&type=template&id=43a14fe8&"
import script from "./info-footer.vue?vue&type=script&lang=js&"
export * from "./info-footer.vue?vue&type=script&lang=js&"
import style0 from "./info-footer.vue?vue&type=style&index=0&id=43a14fe8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports